import _extends from "@babel/runtime/helpers/esm/extends";
import React from 'react';
var _ref = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  d: "M10.058 1v.815H5.943V1H3.479v.815H1V14h14V1.815h-2.464V1h-2.478zm.825 2.431h.826V1.815h-.826v1.616zm-6.592 0h.826V1.815H4.29v1.616zm8.245-.815h1.638v2.515H1.826V2.616H12.536zM1.826 13.185h12.348V5.93H1.826v7.254z"
});
var Calendar = function Calendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16",
    height: "15",
    viewBox: "0 0 16 15"
  }, props), _ref);
};
export default Calendar;